export default __webpack_public_path__ + "static/media/snow-4-day.db4deb09.svg";